import { useCallback } from 'react'
import { useQueryClient } from 'react-query'

import { QueryKeys } from '../../../enums/queryKeys'
import { useInvalidateSalesReports } from './useInvalidateSalesReports'

export const useInvalidateInvoices = () => {
  const queryClient = useQueryClient()
  const { invalidateSalesReports } = useInvalidateSalesReports()

  const invalidateInvoices = useCallback(async () => {
    await queryClient.invalidateQueries(QueryKeys.Invoices)
    await queryClient.invalidateQueries(QueryKeys.InvoicesSummary)
    await queryClient.invalidateQueries(QueryKeys.Creditors)
  }, [queryClient])

  const invalidateInvoice = useCallback(
    async (invoiceId?: string) => {
      await queryClient.invalidateQueries([QueryKeys.Invoice, invoiceId])
      await queryClient.invalidateQueries([QueryKeys.InvoiceReconciliationMatches, invoiceId])
    },
    [queryClient],
  )

  const invalidateExternalInvoice = useCallback(
    async (invoiceId?: string) => {
      await queryClient.invalidateQueries([QueryKeys.ExternalInvoice, invoiceId])
      await queryClient.invalidateQueries(QueryKeys.InvoiceZervant)
      invalidateSalesReports()
    },
    [invalidateSalesReports, queryClient],
  )

  const invalidateExternalInvoices = useCallback(async () => {
    await queryClient.invalidateQueries(QueryKeys.ExternalInvoices)
    await queryClient.invalidateQueries(QueryKeys.InvoicesZervant)
    invalidateSalesReports()
  }, [invalidateSalesReports, queryClient])

  return {
    invalidateInvoices,
    invalidateInvoice,
    invalidateExternalInvoice,
    invalidateExternalInvoices,
  }
}
